function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.66667 0.875H19.25C21.5417 0.875 23.4167 2.80625 23.4167 5.16667C23.4167 10.5312 24.25 15.6813 25.7917 20.4879C26.25 21.99 25.9167 23.6637 24.75 24.8654L15.5833 34.3071C21.5833 46.4525 31.25 56.3662 43.0417 62.5892L52.2083 53.1475C53.0417 52.3321 54.0833 51.9029 55.1667 51.9029C55.5833 51.9029 56.0417 51.9458 56.4583 52.1175C61.125 53.7054 66.1667 54.5637 71.3333 54.5637C73.625 54.5637 75.5 56.495 75.5 58.8554V73.8333C75.5 76.1937 73.625 78.125 71.3333 78.125C32.2083 78.125 0.5 45.4654 0.5 5.16667C0.5 2.80625 2.375 0.875 4.66667 0.875ZM15.2501 9.45833C15.5001 13.2779 16.1251 17.0117 17.1251 20.5737L12.1251 25.7238C10.4168 20.5737 9.33343 15.1233 8.95843 9.45833H15.2501ZM56.3332 61.0441C59.8748 62.0741 63.4998 62.7179 67.1665 62.9754V69.37C61.6665 68.9837 56.3748 67.8679 51.3332 66.1512L56.3332 61.0441Z",
  fill: "#00B357"
});

var SvgClickToCallSuccessful = function SvgClickToCallSuccessful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 79,
    viewBox: "0 0 76 79",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/click-to-call-successful.637f872c.svg";
export { SvgClickToCallSuccessful as ReactComponent };